import React, { useCallback, useState } from 'react'
import Button from '../../ui/button'
import TextField from '../../ui/text-field'
import styles from './AddBotForm.module.css'

export interface AddBotFormProps {
    onSubmit: (x: { name: string }) => any
    onCancel: () => any
}

export default function AddBotForm(props: AddBotFormProps) {
    const [name, setName] = useState("")
    const trimedName = name.trim()
    const canSubmit = trimedName.length > 0
    const submit = useCallback(() => {
        if (canSubmit) props.onSubmit({ name: trimedName })
    }, [props, canSubmit, trimedName])
    const cancel = useCallback(() => props.onCancel(), [props])
    return (
        <div className={styles.container}>
            <TextField label="Bot name" onChange={(e) => setName(e.target.value)} />
            <Button variant="outlined" onClick={submit} disabled={!canSubmit}>
                Add
            </Button>
            <Button variant="text" onClick={cancel}>
                Cancel
            </Button>
        </div>
    )
}